import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';

const RoleList = ({ onSelectRole, refresh, onRoleDeleted }) => {
  const [roles, setRoles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(null);

  useEffect(() => {
    const fetchRoles = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get('/roles/roles');
          if (response && response.data) {
          setRoles(response.data);
        } else {
          setError('Неправильный формат данных с сервера: некорректные данные');
        }
      } catch (err) {
        console.error('Ошибка при загрузке ролей:', err);
        setError('Ошибка при загрузке ролей: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, [refresh]);

  const handleRoleClick = (role) => {
    if (onSelectRole) {
      onSelectRole(role);
    }
  };

   const handleRoleDelete = async (roleId) => {
        if (window.confirm('Вы действительно хотите удалить эту роль?')) {
            setDeleteLoading(roleId);
            setError(null);

            console.log("Начало запроса удаления:", roleId);

            try {
                const response = await api.delete(`/roles/roles/${roleId}`);
                 console.log("Ответ получен:", response, roleId);


                if (response) {
                   try {
                       const data = typeof response === 'string' ? JSON.parse(response) : (response.data ? (typeof response.data === 'string' ? JSON.parse(response.data) : response.data) : response);

                        console.log("Распарсенные данные:", data, roleId);
                        if (data && data.status === "success") {
                            console.log('Роль успешно удалена:', roleId);
                            setRoles(prevRoles => prevRoles.filter(role => role.id !== roleId));
                             if (onRoleDeleted) {
                                 onRoleDeleted();
                             }
                        } else {
                            console.error('Ошибка при удалении роли, код:', data ? JSON.stringify(data) : 'нет ответа' , roleId);
                           setError(`Ошибка при удалении роли: ${data ? JSON.stringify(data) : 'нет ответа'}`);
                        }
                    } catch (parseError) {
                          console.error('Ошибка при парсинге JSON:', response, parseError)
                         setError('Ошибка при парсинге JSON: ' + parseError.message);
                    }

                } else {
                    console.error('Ошибка при удалении роли, нет response', roleId);
                   setError('Ошибка при удалении роли, нет response');
                }

            } catch (error) {
                console.error('Ошибка при удалении роли:', error);
                setError('Ошибка при удалении роли: ' + error.message);
            } finally {
                setDeleteLoading(null);
            }
        }
    };


  if (loading) {
    return <div>Загрузка ролей...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="main-block">
    <ul className="role-list">
      {roles &&
        roles.map((role) => (
          <li key={role.id} className="role-item">
            <span onClick={() => handleRoleClick(role)} style={{ cursor: 'pointer', marginRight: '10px' }}>
              {role.name}
            </span>
            <button
              onClick={() => handleRoleDelete(role.id)}
              className="delete-button"
              disabled={deleteLoading === role.id}
            >
              {deleteLoading === role.id ? 'Удаление...' : 'Удалить'}
            </button>
          </li>
        ))}
    </ul>
    </div >
  );
};

export default RoleList;
